module.exports = __webpack_public_path__ + "img/uy.84ac071f.svg";